import { CookieConsents } from '@creditornot/cwc-cookie-sdk';
import React, { MouseEventHandler, useCallback, useState } from 'react';
import styled from 'styled-components';

import { CookieConsentsBanner } from './CookieConsentsBanner';
import { ManageCookieConsentsModal } from './ManageCookieConsentsModal';

export type ManageCookieConsentsControllerProps = {
  show: boolean;
  initialConsents: CookieConsents;
  privacyPolicyUrl: string;
  onAcceptDefaultConsentsClick: MouseEventHandler<HTMLButtonElement>;
  onSubmitCookieConsents: (consents: CookieConsents) => void;
  onSubmitConsentsFailed: (error: any) => void;
};

const Background = styled.div`
  background-color: rgba(32 32 36 / 50%);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

export const ManageCookieConsentsController = ({
  show,
  initialConsents,
  privacyPolicyUrl,
  onAcceptDefaultConsentsClick,
  onSubmitCookieConsents,
  onSubmitConsentsFailed,
}: ManageCookieConsentsControllerProps) => {
  const [showManageCookieConsentsModal, setShowManageCookieConsentsModal] = useState(false);

  const handleRequestManageConsentsOpen = useCallback(() => {
    setShowManageCookieConsentsModal(true);
  }, []);

  const handleRequestManageConsentsClose = useCallback(() => {
    setShowManageCookieConsentsModal(false);
  }, []);

  return (
    <>
      {(showManageCookieConsentsModal || show) && <Background key="bg" tabIndex={-1} />}
      <CookieConsentsBanner
        show={!showManageCookieConsentsModal && show}
        onAcceptDefaultConsentsClick={onAcceptDefaultConsentsClick}
        privacyPolicyUrl={privacyPolicyUrl}
        onManageConsentsClick={handleRequestManageConsentsOpen}
      />

      <ManageCookieConsentsModal
        initialConsents={initialConsents}
        show={showManageCookieConsentsModal}
        onSubmit={onSubmitCookieConsents}
        onSubmitFailed={onSubmitConsentsFailed}
        onClose={handleRequestManageConsentsClose}
      />
    </>
  );
};
